// Only normalize known SPA pages. Static news files and asset directories keep
// their deployment URLs under /v2/.
export function canonicalSpaPath(pathname, routes) {
  if (!/^\/v2(?:\/|$)/.test(pathname)) return pathname;
  let candidate = pathname.slice(3).replace(/\/+$/, '') || '/';
  if (candidate === '/index.html') candidate = '/';
  const known = new Set();
  function visit(records, parent = '') {
    for (const record of records) {
      const path = record.path.startsWith('/') ? record.path : `${parent}/${record.path}`;
      const normalized = path.replace(/\/+$/, '') || '/';
      known.add(normalized);
      if (record.children) visit(record.children, normalized === '/' ? '' : normalized);
    }
  }
  visit(routes);
  return known.has(candidate) ? candidate : pathname;
}
